import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Clínica ")
const _hoisted_2 = {
  key: 1,
  class: "form mb-48"
}
const _hoisted_3 = { class: "row gx-32" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "col-8" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-add-alt fw-bold me-8" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, null, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_v_loader, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_form_group_input_text, {
                      label: _ctx.$t('Nombre'),
                      value: _ctx.name,
                      class: "mb-24",
                      "yup-errors-variable": _ctx.errors.name,
                      autocomplete: "off",
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.name = $event))
                    }, null, 8, ["label", "value", "yup-errors-variable"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_form_group_select, {
                      label: _ctx.$t('Prefijo tel.'),
                      class: "mb-24",
                      "yup-errors-variable": _ctx.errors.phoneNumberPrefix
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          class: _normalizeClass({'is-invalid': !!_ctx.errors.phoneNumberPrefix}),
                          options: _ctx.formsSettings.valid_phone_number_prefix_options,
                          reduce: returnValue => returnValue.key,
                          "select-on-key-codes": [188, 13],
                          modelValue: _ctx.phoneNumberPrefix,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phoneNumberPrefix) = $event))
                        }, {
                          "no-options": _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                          ]),
                          _: 1
                        }, 8, ["class", "options", "reduce", "modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label", "yup-errors-variable"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_v_form_group_input_text, {
                      label: _ctx.$t('Teléfono'),
                      type: "number",
                      value: _ctx.phoneNumber,
                      class: "mb-24",
                      "yup-errors-variable": _ctx.errors.phoneNumber,
                      autocomplete: "off",
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.phoneNumber = $event))
                    }, null, 8, ["label", "value", "yup-errors-variable"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_v_form_group_input_text, {
                      label: _ctx.$t('Dirección'),
                      value: _ctx.address,
                      class: "mb-24",
                      "yup-errors-variable": _ctx.errors.address,
                      autocomplete: "off",
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.address = $event))
                    }, null, 8, ["label", "value", "yup-errors-variable"])
                  ])
                ])
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_button, {
            variant: "link-secondary",
            class: "me-24",
            "aria-label": _ctx.$t('Cancelar'),
            "data-bs-dismiss": "modal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"]),
          _createVNode(_component_v_button, {
            variant: "secondary",
            class: "btn-icon",
            "aria-label": _ctx.$t('Actualizar'),
            disabled: !_ctx.meta.valid || _ctx.accepted,
            onClick: _ctx.updateClinic,
            "is-loading": _ctx.accepted
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Actualizar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "disabled", "onClick", "is-loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}